import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Action, Figure } from '@studiometa/ui';
import { isDev } from './config.js';
import TextAppear from './components/TextAppear.js';
import ParallaxMedia from './components/ParallaxMedia.js';
import Header from './components/Header.js';
import Circle from './components/Circle.js';
import Fade from './components/Fade.js';
import Rosace from './components/Rosace.js';

/**
 * @typedef {{
 *   $children: {
 *     Figure: Figure[],
 *     Video: Array<Promise<import('./components/Video.js').default>>
 *     Accordion: Array<Promise<import('./components/Accordion.js').default>>
 *     Slider: Array<Promise<import('./components/Slider.js').default>>
 *     Cal: Array<Promise<import('./components/Cal.js').default>>
 *   }
 * }} AppProps
 */

/**
 * App class.
 * @augments {Base<AppProps>}
 */
class App extends Base {
  /**
   * App config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'App',
    log: isDev(),
    components: {
      Header,
      Figure,
      Action,
      ParallaxMedia,
      Circle,
      Rosace,
      '[data-fade]': Fade,
      '.type-animate': TextAppear,
      GradientCircle: () => importWhenVisible(() => import('./components/GradientCircle.js'), 'GradientCircle'),
      Slider: () => importWhenVisible(() => import('./components/Slider.js'), 'Slider'),
      Video: () => importWhenVisible(() => import('./components/Video.js'), 'Video'),
      Accordion: () => importWhenVisible(() => import('./components/Accordion.js'), 'Accordion'),
      '[href*="#cal"]': () => import('./components/Cal.js'),
    },
  };
}

export default createApp(App, {
  root: document.documentElement,
  screens: {
    '2xs': '0rem',
    xs: '30rem',
    s: '40rem',
    m: '48rem',
    l: '64rem',
    xl: '80rem',
    '2xl': '96rem',
    '3xl': '120rem',
  },
});
